import React from 'react'
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate } from 'react-router-dom';

// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import { Image } from 'react-bootstrap';


export default function Game2ExerciseScenario() {
    const navigate = useNavigate();

    function toDashboradVerfy2(e) {
        navigate('/game2dashboradverfy2')
    }

    return (
        <div>
            <TitleBar backLastPage="" lastPageName="point" />
            <div className='text-center'>
                <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '40px', paddingBottom: '1rem', fontWeight: 'bold' }}>Case Scenario:</p></b>
            </div>
            <div className="ExerciseScenariodiv">
                <div className='text-center ' style={{ marginTop: '0.5rem', marginBottom: '0.5rem', fontSize: '20px' }}><b>Use the zero-knowledge proof to prove whether the order data has changed</b></div>
                <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>Suppose a wine merchant accepts four order a day and encrypts the information using the <b>MERKLE TREE</b> method to form a block. The wine merchant wants to know whether the information of Order2 has been tampered with, please help verify it.</div>
                <div className='text-center' style={{ padding: '1rem' }}>
                    <Image src="/Exercise.png" fluid />
                </div>
            </div>
            <div className="ExerciseScenarioPage_div_Next">
                <input className="ExerciseScenarioPage_btn_Next" type="button" value="Next" onClick={e => toDashboradVerfy2()} />
            </div>

        </div>
    )
}